import { BaseApiClient } from './base-client'
import { API_ROUTES, interpolateRoute } from '@super/shared-types'
import type {
  DecisionLog,
  ApiOffsetPaginatedResponse,
} from '@super/shared-types'

export class DecisionLogApiClient extends BaseApiClient {
  async getBySession(
    sessionId: string,
    companyId: string,
    opts: { limit?: number; offset?: number } = {},
  ): Promise<ApiOffsetPaginatedResponse<DecisionLog>> {
    const params = new URLSearchParams({
      sessionId,
      companyId,
      limit: String(opts.limit ?? 50),
      offset: String(opts.offset ?? 0),
    })
    return this.request<ApiOffsetPaginatedResponse<DecisionLog>>(
      `${API_ROUTES.ADMIN.DECISION_LOGS.LIST}?${params.toString()}`,
    )
  }

  async getById(id: string, companyId: string): Promise<DecisionLog> {
    const path = interpolateRoute(API_ROUTES.ADMIN.DECISION_LOGS.BY_ID, { id })
    return this.request<DecisionLog>(`${path}?companyId=${companyId}`)
  }
}

export const decisionLogApiClient = new DecisionLogApiClient()
